import React from "react";
import { List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import MapIcon from "@mui/icons-material/Map";
import type { PublicPackageResponse } from "../../publicPackages/publicPackagesApi";

export function TimelineSummary({ forPackage }: { forPackage: PublicPackageResponse }) {
  return (
    <Paper elevation={0} sx={{ p: 4, borderRadius: 1, border: "1px solid rgba(0,0,0,0.08)" }}>
      <Typography
        variant="subtitle2"
        sx={{
          textTransform: "uppercase",
          fontWeight: "bold",
          color: "text.secondary",
          mb: 2,
        }}
      >
        Trasa wycieczki w skrócie
      </Typography>
      <List dense disablePadding>
        {forPackage.days.map((item, index) => (
          <ListItem key={index} disableGutters sx={{ alignItems: "flex-start" }}>
            <ListItemIcon sx={{ minWidth: 28, mt: 0.5 }}>
              <MapIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText
              primary={item.title}
              slotProps={{
                primary: { variant: "body2" },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
